import type { AmplitudeInstance } from '.';

export interface Ids {
  deviceId: string | undefined;
  sessionId: number | undefined;
  userId: string | undefined;
}

export const getIds = (amplitude?: AmplitudeInstance): Ids => {
  if (!amplitude)
    return {
      deviceId: undefined,
      sessionId: undefined,
      userId: undefined,
    };
  return {
    deviceId: amplitude.getDeviceId(),
    sessionId: amplitude.getSessionId(),
    userId: amplitude.getUserId(),
  };
};
